import { defineNuxtPlugin, showError } from '#app'
import { useLayoutStore, useNuxtApp } from '#imports'

// When a page throws createError during setup (e.g. 404 on store detail),
// the GSAP afterEnter hook never fires — layout.transitioning stays true forever.
// This plugin resets it via two paths:
// 1. app:error — fires during SSR hydration errors
// 2. unhandledrejection — fires during CSR navigation (Vue Router doesn't route
//    async setup rejections to vueApp.config.errorHandler, so app:error never fires)
export default defineNuxtPlugin({
  parallel: true,
  setup () {
    const nuxtApp = useNuxtApp()
    const layout = useLayoutStore()

    nuxtApp.hook('app:error', () => {
      layout.transitioning = false
    })

    window.addEventListener('unhandledrejection', (event) => {
      const err = event.reason
      if (err && typeof err.statusCode === 'number') {
        event.preventDefault()
        layout.transitioning = false
        nuxtApp.runWithContext(() => showError(err))
      }
    })
  }
})
